module.exports = __webpack_public_path__ + "static/polona-251d38145a2a332f588d018d0b446a0a.jpg";